import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WaterDamageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"water_damage"}/>
}
